import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  SimpleChanges, OnChanges,
} from '@angular/core';
import { componentStylesByTheme } from '../utils/theme.utils';
import { THEME_TOKEN, Theme } from '../types/theme.types';
import {
  datePickerButtonSAG,
  datePickerButtonSHS,
  datePickerContainerSAG,
  datePickerContainerSHS,
  datePickerDayBoxSAG,
  datePickerDayBoxSHS,
  datePickerDayTextSAG,
  datePickerDayTextSHS,
  datePickerDisabledDayBoxSAG,
  datePickerDisabledDayBoxSHS,
  datePickerDividerSAG,
  datePickerDividerSHS,
  datePickerMonthBoxSAG,
  datePickerMonthBoxSHS,
  datePickerTimeDividerSAG,
  datePickerTimeDividerSHS,
  datePickerTimeInputSAG,
  datePickerTimeInputSHS,
  datePickerTopTextSAG,
  datePickerTopTextSHS,
} from './date-picker.styles';

@Component({
  selector: 'sag-ui-date-picker',
  template: `
    <div [class]="containerStyles">
      <div class="flex items-center justify-between p-6">
        <span
          [class]="
            pickerButtonStyles +
            ' icon-chevron-left rounded-full cursor-pointer p-2'
          "
          (click)="previousMonth()"
        ></span>
        <span [class]="topTextStyles">
          <span (click)="changeView('months')" class="mr-1 cursor-pointer">{{
            localizedMonths[selectedMonth]
          }}</span>
          <span (click)="changeView('years')" class="cursor-pointer">{{
            selectedYear
          }}</span></span
        >
        <span
          [class]="
            pickerButtonStyles +
            ' icon-chevron-right rounded-full cursor-pointer p-2'
          "
          (click)="nextMonth()"
        ></span>
      </div>
      <hr [class]="dividerStyles" />
      @switch (view) {
        @case ('days') {
          <div
            class="grid grid-cols-7 grid-rows-6 items-center justify-center gap-2 p-6"
          >
            <div [class]="dayTextStyles" *ngFor="let day of localizedWeekdays">
              {{ day }}
            </div>
            <div
              [class]="dayBoxDisabledStyles"
              *ngFor="let day of previousMonthsDates"
            >
              {{ day }}
            </div>
            <div
              [class]="dayBoxStyles"
              [attr.data-selected]="isDaySelected(day)"
              (click)="dateSelected(day)"
              *ngFor="let day of dates"
            >
              {{ day }}
            </div>
            <div
              [class]="dayBoxDisabledStyles"
              *ngFor="let day of nextMonthsDates"
            >
              {{ day }}
            </div>
          </div>
        }
        @case ('months') {
          <div
            class="grid grid-cols-4 grid-rows-3 items-center justify-center gap-2 p-6"
          >
            <div
              [class]="monthBoxStyles"
              [attr.data-selected]="selectedMonth === i"
              *ngFor="let month of localizedMonths; let i = index"
              (click)="
                selectedMonth = i;
                view = 'days';
                updateDisplayedDates(selectedYear, selectedMonth)
              "
            >
              {{ month }}
            </div>
          </div>
        }
        @case ('years') {
          <div class="p-6 py-2">
            <span
              [class]="
                pickerButtonStyles +
                ' icon-chevron-up rounded-md flex items-center justify-center w-full cursor-pointer p-2'
              "
              (click)="previousYears()"
            ></span>
            <div
              class="grid grid-cols-4 grid-rows-3 items-center justify-center gap-2 py-2"
            >
              <div
                [class]="monthBoxStyles"
                [attr.data-selected]="selectedYear === year"
                *ngFor="let year of displayedYears"
                (click)="
                  selectedYear = year;
                  view = 'months';
                  updateDisplayedDates(selectedYear, selectedMonth)
                "
              >
                {{ year }}
              </div>
            </div>
            <span
              [class]="
                pickerButtonStyles +
                ' icon-chevron-down rounded-md flex items-center justify-center w-full cursor-pointer p-2'
              "
              (click)="nextYears()"
            ></span>
          </div>
        }
      }
      @if (time) {
        <hr [class]="dividerStyles" />
        <div class="flex items-center justify-center gap-2 p-4">
          <div class="flex flex-col">
            <span
              [class]="
                pickerButtonStyles +
                ' text-sm font-semibold icon-chevron-up w-[50px] cursor-pointer flex items-center justify-center mb-[2px] rounded-sm'
              "
              (click)="
                selectedHours = Math.min(selectedHours + 1, 23); updateTime()
              "
            ></span>
            <input
              [class]="timeInputStyles"
              [(ngModel)]="selectedHours"
              (change)="updateTimeInput($event, 'hours')"
              type="number"
              min="0"
              max="23"
            />
            <span
              [class]="
                pickerButtonStyles +
                ' text-sm font-semibold icon-chevron-down w-[50px] cursor-pointer flex items-center justify-center mb-[2px] rounded-sm'
              "
              (click)="
                selectedHours = Math.max(selectedHours - 1, 0); updateTime()
              "
            ></span>
          </div>
          <span [class]="timeDividerStyles">:</span>
          <div class="flex flex-col">
            <span
              [class]="
                pickerButtonStyles +
                ' text-sm font-semibold icon-chevron-up w-[50px] cursor-pointer flex items-center justify-center mb-[2px] rounded-sm'
              "
              (click)="
                selectedMinutes = Math.min(selectedMinutes + 1, 59);
                updateTime()
              "
            ></span>
            <input
              [class]="timeInputStyles"
              [value]="selectedMinutes"
              (change)="updateTimeInput($event, 'minutes')"
              type="number"
              min="0"
              max="59"
            />
            <span
              [class]="
                pickerButtonStyles +
                ' text-sm font-semibold icon-chevron-down w-[50px] cursor-pointer flex items-center justify-center mb-[2px] rounded-sm'
              "
              (click)="
                selectedMinutes = Math.max(selectedMinutes - 1, 0); updateTime()
              "
            ></span>
          </div>
          @if (time === 'hh:mm:ss') {
            <span [class]="timeDividerStyles">:</span>
            <div class="flex flex-col">
              <span
                [class]="
                  pickerButtonStyles +
                  ' text-sm font-semibold icon-chevron-up w-[50px] cursor-pointer flex items-center justify-center mb-[2px] rounded-sm'
                "
                (click)="
                  selectedSeconds = Math.min(selectedSeconds + 1, 59);
                  updateTime()
                "
              ></span>
              <input
                [class]="timeInputStyles"
                [value]="selectedSeconds"
                (change)="updateTimeInput($event, 'seconds')"
                type="number"
                min="0"
                max="59"
              />
              <span
                [class]="
                  pickerButtonStyles +
                  ' text-sm font-semibold icon-chevron-down w-[50px] cursor-pointer flex items-center justify-center mb-[2px] rounded-sm'
                "
                (click)="
                  selectedSeconds = Math.max(selectedSeconds - 1, 0);
                  updateTime()
                "
              ></span>
            </div>
          }
        </div>
      }
    </div>
  `,
})
export class DatePickerComponent implements OnInit, OnChanges {
  @Input() time?: 'hh:mm' | 'hh:mm:ss';
  @Input() lang?: 'en' | 'de';
  @Input() date: Date = new Date();
  @Output() dateChanged: EventEmitter<{ value: Date; emit: boolean }> =
    new EventEmitter<{ value: Date; emit: boolean }>();

  protected currentMonth: number = new Date().getMonth();
  protected currentYear: number = new Date().getFullYear();
  protected selectedMonth: number = this.date.getMonth();
  protected selectedYear: number = this.date.getFullYear();
  protected selectedDay: number = this.date.getDate();
  protected selectedHours: number = this.date.getHours();
  protected selectedMinutes: number = this.date.getMinutes();
  protected selectedSeconds: number = this.date.getSeconds();
  protected previousMonthsDates: number[] = [];
  protected dates: number[] = [];
  protected nextMonthsDates: number[] = [];
  protected view: 'days' | 'months' | 'years' = 'days';
  protected displayedYears: number[] = Array.from(
    { length: 12 },
    (_, i) => new Date().getFullYear() + i,
  );
  protected Math: Math = Math;

  constructor(@Inject(THEME_TOKEN) private readonly theme: Theme) {}

  ngOnInit() {
    this.updateDisplayedDates(this.selectedYear, this.selectedMonth);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['date'] && this.date) {
      this.selectedMonth = this.date.getMonth();
      this.selectedYear = this.date.getFullYear();
      this.selectedDay = this.date.getDate();
      this.selectedHours = this.date.getHours();
      this.selectedMinutes = this.date.getMinutes();
      this.selectedSeconds = this.date.getSeconds();
      this.updateDisplayedDates(this.selectedYear, this.selectedMonth);
    }
  }

  protected isDaySelected(day: number) {
    if (!this.date) return false;

    return (
      day === this.date.getDate() &&
      this.selectedMonth === this.date.getMonth() &&
      this.selectedYear === this.date.getFullYear()
    );
  }

  protected get userLanguage() {
    return this.lang || navigator.language;
  }

  protected get localizedWeekdays() {
    const isGerman = this.userLanguage.startsWith('de');
    return isGerman
      ? ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So']
      : ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  }

  protected get localizedMonths() {
    const isGerman = this.userLanguage.startsWith('de');
    return isGerman
      ? [
          'Januar',
          'Februar',
          'März',
          'April',
          'Mai',
          'Juni',
          'Juli',
          'August',
          'September',
          'Oktober',
          'November',
          'Dezember',
        ]
      : [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ];
  }

  private parseNumber(value: string | number): number {
    return typeof value === 'string' ? parseInt(value, 10) : value;
  }

  protected updateTimeInput(
    event: Event,
    type: 'hours' | 'minutes' | 'seconds',
  ) {
    event.preventDefault();
    event.stopPropagation();
    const value = this.parseNumber((event.target as HTMLInputElement).value);

    switch (type) {
      case 'hours':
        this.selectedHours = value;
        break;
      case 'minutes':
        this.selectedMinutes = value;
        break;
      case 'seconds':
        this.selectedSeconds = value;
        break;
    }

    this.dateChanged.emit({
      value: new Date(
        this.selectedYear,
        this.selectedMonth,
        this.selectedDay,
        this.selectedHours,
        this.selectedMinutes,
        this.selectedSeconds,
      ),
      emit: false,
    });
  }

  protected updateTime() {
    this.dateChanged.emit({
      value: new Date(
        this.selectedYear,
        this.selectedMonth,
        this.selectedDay,
        this.selectedHours,
        this.selectedMinutes,
        this.selectedSeconds,
      ),
      emit: false,
    });
  }

  protected dateSelected(day: number) {
    this.selectedDay = day;
    this.dateChanged.emit({
      value: new Date(
        this.selectedYear,
        this.selectedMonth,
        day,
        this.selectedHours,
        this.selectedMinutes,
        this.selectedSeconds,
      ),
      emit: !this.time,
    });
  }

  protected changeView(view: 'days' | 'months' | 'years') {
    this.view = view;
  }

  protected previousYears() {
    this.displayedYears = this.displayedYears.map((year) => year - 12);
  }

  protected nextYears() {
    this.displayedYears = this.displayedYears.map((year) => year + 12);
  }

  protected previousMonth() {
    this.selectedMonth--;
    if (this.selectedMonth < 0) {
      this.selectedMonth = 11;
      this.selectedYear--;
    }
    this.updateDisplayedDates(this.selectedYear, this.selectedMonth);
  }

  protected nextMonth() {
    this.selectedMonth++;
    if (this.selectedMonth > 11) {
      this.selectedMonth = 0;
      this.selectedYear++;
    }
    this.updateDisplayedDates(this.selectedYear, this.selectedMonth);
  }

  protected updateDisplayedDates(year: number, month: number) {
    const daysInWeek = 7;
    const weeksInGrid = 5;
    const totalDays = daysInWeek * weeksInGrid;

    const firstDayOfMonth = new Date(year, month, 1);
    const lastDayOfMonth = new Date(year, month + 1, 0);
    const firstDayOfWeek = firstDayOfMonth.getDay() || 7; // Adjusting for Monday as first day
    const daysInMonth = lastDayOfMonth.getDate();

    this.previousMonthsDates = [];
    this.dates = [];
    this.nextMonthsDates = [];

    // Fill previous month days
    for (let i = firstDayOfWeek - 1; i > 0; i--) {
      const day = new Date(year, month, 1 - i).getDate();
      this.previousMonthsDates.push(day);
    }

    // Fill current month days
    for (let i = 1; i <= daysInMonth; i++) {
      this.dates.push(i);
    }

    // Fill next month days
    let nextMonthDay = 1;
    while (
      this.dates.length +
        this.previousMonthsDates.length +
        this.nextMonthsDates.length <
      totalDays
    ) {
      this.nextMonthsDates.push(nextMonthDay++);
    }
  }

  protected get containerStyles() {
    return componentStylesByTheme(
      this.theme,
      datePickerContainerSAG,
      datePickerContainerSHS,
    )();
  }

  protected get pickerButtonStyles() {
    return componentStylesByTheme(
      this.theme,
      datePickerButtonSAG,
      datePickerButtonSHS,
    )();
  }

  protected get topTextStyles() {
    return componentStylesByTheme(
      this.theme,
      datePickerTopTextSAG,
      datePickerTopTextSHS,
    )();
  }

  protected get dayTextStyles() {
    return componentStylesByTheme(
      this.theme,
      datePickerDayTextSAG,
      datePickerDayTextSHS,
    )();
  }

  protected get dayBoxDisabledStyles() {
    return componentStylesByTheme(
      this.theme,
      datePickerDisabledDayBoxSAG,
      datePickerDisabledDayBoxSHS,
    )();
  }

  protected get dayBoxStyles() {
    return componentStylesByTheme(
      this.theme,
      datePickerDayBoxSAG,
      datePickerDayBoxSHS,
    )();
  }

  protected get monthBoxStyles() {
    return componentStylesByTheme(
      this.theme,
      datePickerMonthBoxSAG,
      datePickerMonthBoxSHS,
    )();
  }

  protected get timeInputStyles() {
    return componentStylesByTheme(
      this.theme,
      datePickerTimeInputSAG,
      datePickerTimeInputSHS,
    )();
  }

  protected get timeDividerStyles() {
    return componentStylesByTheme(
      this.theme,
      datePickerTimeDividerSAG,
      datePickerTimeDividerSHS,
    )();
  }

  protected get dividerStyles() {
    return componentStylesByTheme(
      this.theme,
      datePickerDividerSAG,
      datePickerDividerSHS,
    )();
  }
}
